import type { Tone } from '@wl/ui';
import type { PlatformRole } from '../lib/types';
import type { TenantStatus, UserStatus } from '../pages/tenants/types';
import type { ActorType, LoginEventKind } from './types';

export const PLATFORM_ROLES: Record<PlatformRole, { label: string; tone: Tone; description: string }> = {
  owner: { label: 'Sahip', tone: 'accent', description: 'Tüm yetkiler; yönetici davet eder ve rolleri değiştirir' },
  admin: { label: 'Yönetici', tone: 'primary', description: 'Tenant ve katalog işlemleri; yönetici ekleyemez' },
  support: { label: 'Destek', tone: 'neutral', description: 'Yalnızca görüntüleme ve tenant’a destek girişi' },
};

export const TENANT_STATUS: Record<TenantStatus, { label: string; tone: Tone }> = {
  active: { label: 'Aktif', tone: 'success' },
  suspended: { label: 'Askıda', tone: 'warning' },
  archived: { label: 'Arşivlendi', tone: 'neutral' },
};

export const USER_STATUS: Record<UserStatus, { label: string; tone: Tone }> = {
  pending: { label: 'Davet bekliyor', tone: 'neutral' },
  active: { label: 'Aktif', tone: 'success' },
  suspended: { label: 'Askıda', tone: 'warning' },
  deleted: { label: 'Silindi', tone: 'danger' },
};

export const LOGIN_EVENT_LABELS: Record<LoginEventKind, string> = {
  login_succeeded: 'Giriş başarılı',
  login_failed: 'Giriş başarısız',
  mfa_required: 'Doğrulama kodu istendi',
  mfa_failed: 'Doğrulama kodu hatalı',
  session_refreshed: 'Oturum yenilendi',
  refresh_rejected: 'Yenileme reddedildi',
  logout: 'Çıkış',
  invite_accepted: 'Davet kabul edildi',
  password_reset: 'Şifre sıfırlandı',
  email_verified: 'E-posta doğrulandı',
  handoff: 'Platformdan giriş',
};

const FAILED: LoginEventKind[] = ['login_failed', 'mfa_failed', 'refresh_rejected'];

export function loginEventTone(e: LoginEventKind): Tone {
  if (FAILED.includes(e)) return 'danger';
  if (e === 'handoff') return 'accent';
  if (e === 'login_succeeded') return 'success';
  return 'neutral';
}

export const ACTOR_LABELS: Record<ActorType, string> = { user: 'Kullanıcı', platform_admin: 'Platform yöneticisi', system: 'Sistem' };

/** Kısaltılmış kimlik (UUID'nin ilk 8 hanesi). */
export function shortId(id: string | null | undefined): string {
  return id ? id.slice(0, 8) : '—';
}
